import { Navigate, RouteObject } from 'react-router-dom'

import { MembershipLayout } from '@layouts/membership/MembershipLayout'
import MembershipProfileLayout from '@layouts/membership/MembershipProfileLayout'
import MembershipProfilesPage from '@pages/membership/membership-profiles/MembershipProfilesPage'
import { membershipProfileSectionRoutes } from './MembershipProfileSectionRoutes'

const membersRoutes: RouteObject[] = [
  {
    element: <MembershipLayout />,
    children: [
      { path: 'list', element: <MembershipProfilesPage /> },
      {
        path: ':membershipProfileId',
        element: <MembershipProfileLayout />,
        children: membershipProfileSectionRoutes,
      },
      { index: true, element: <Navigate to="list" replace /> },
      { path: '*', element: <Navigate to="list" replace /> },
    ],
  },
]

export default membersRoutes
